let globalAttachmentStyles = require('./globalattachmentstyles.global.scss');
let webfontStyles = require('./webfontstyles.global.scss');
let webfontglyphs = require('./webfontglyphs.global.scss');

export * from 'owa-global-styles';
export { globalAttachmentStyles, webfontStyles, webfontglyphs };
